import { Injectable } from '@angular/core';
import { IPlugin } from '../../models/plugin';
import { ILink } from '../../models/link';
import { ISession } from '../../models/session';
import { has } from 'ramda/es';
import { SessionsService } from '../sessions/sessions.service';

const DEFAULT_SIZE = { width: 1000, height: 1000 };
const WALL_SIZE = { width: 1280, height: 720 };
export const SESSION_NAME_PREFIX = 'sessions.details.links';

@Injectable()
export class PreviewService {
  private webeventStatus = [
    { type: 'teasing', status: 'BeforeChatContent' },
    { type: 'live', status: 'DuringChatContent' },
    { type: 'closing', status: 'AfterChatContent' },
    { type: 'replay', status: 'TranscriptContent' }
  ];
  private guestModeFilter = [
    {
      name: `${SESSION_NAME_PREFIX}.Wall-01-ModerationBanner`,
      guestMode: true
    },
    {
      name: `${SESSION_NAME_PREFIX}.Wall-05-Bubble`,
      guestMode: false
    }
  ];

  constructor(private sessionService: SessionsService) {}

  private previewPrefix(session: ISession, status = 'DuringChatContent') {
    const languagesToIds = {
      french: 1,
      english: 2
    };
    const languageId = languagesToIds[session.language] || 1;
    return `op=preview&box=${status}&LanguageID=${languageId}&cmd=&boxType=s`;
  }

  getWebEventLinks(session: ISession, plugins?: IPlugin[]): ILink[] {
    const replay = plugins.find(
      x => (x.name === 'transcript_publish' || x.name === 'video_replay_publish') && x.isActivated
    );

    return this.webeventStatus
      .filter(item => (item.type === 'replay' && replay) || item.type !== 'replay')
      .map((event, i) => {
        return {
          name: `sessions.${event.type}`,
          url: encodeURIComponent(
            `${session.url}/l/Webevent-00-AllModules?${this.previewPrefix(session, event.status)}`
          ),
          size: DEFAULT_SIZE
        };
      });
  }

  getLinks(type: string, session: ISession, plugins?: IPlugin[]): ILink[] {
    if (type === 'webevent') {
      return this.getWebEventLinks(session, plugins);
    }
    const defaultLinks: ILink[] =
      type === 'webapp'
        ? [
            {
              name: `${SESSION_NAME_PREFIX}.WebApp-S01-Home`, // By default we must have the home page:
              url: encodeURIComponent(
                `${
                  session.urls.find(url => url.name === 'WebApp-S01-Home').link
                }?${this.previewPrefix(session)}`
              ),
              size: DEFAULT_SIZE
            }
          ]
        : [];
    return plugins
      .filter((plugin: IPlugin) => has('activate', plugin) && plugin.isActivated)
      .map((plugin: IPlugin) => {
        // Then, filter for the type that the component asked for
        return plugin.activate
          .filter(preview => preview.for === type)
          .map(preview => {
            const { link } = session.urls.find(url => url.name === preview.name);
            // Create the link
            return {
              name: `${SESSION_NAME_PREFIX}.${preview.name}`,
              url: encodeURIComponent(`${link}?${this.previewPrefix(session)}`),
              size: type === 'wall' ? WALL_SIZE : DEFAULT_SIZE
            };
          });
      })
      .reduce((links: ILink[], val) => links.concat(val), defaultLinks) // flatten
      .reduce((links: ILink[], val) => {
        // Remove duplicated entries
        return links.some(link => link.name === val.name) ? links : links.concat(val);
      }, [])
      .filter((link: ILink) => {
        // If the guest mode is activated show: Wall-05-Bubble otherwise show Wall-01-ModerationBanner
        return !this.guestModeFilter.some(
          filter =>
            link.name === filter.name && this.sessionService.guestMode$.value === filter.guestMode
        );
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/preview/preview.service.ts